<app-side-menu>
  <div class="preventive-maintenance-form-content">
    <!-- Header -->
    <div class="row mb-4">
      <div class="col-12">
        <div class="page-header">
          <div class="d-flex align-items-center">
            <button 
              type="button"
              class="btn btn-outline-secondary me-3"
              (click)="cancel()">
              <i class="fas fa-arrow-left me-2"></i>
              Voltar
            </button>
            <div>
              <h1 class="page-title">
                <i class="fas fa-tools me-3"></i>
                {{ isEditMode ? 'Editar Preventiva' : 'Nova Preventiva' }}
              </h1>
              <p class="page-subtitle">{{ isEditMode ? 'Atualize as informações da preventiva' : 'Cadastre uma nova preventiva' }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Loading -->
    <div *ngIf="loading && isEditMode" class="loading-container">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Carregando...</span>
      </div>
      <p>Carregando dados da preventiva...</p>
    </div>

    <!-- Error -->
    <div *ngIf="error" class="alert alert-danger alert-dismissible fade show" role="alert">
      <i class="fas fa-exclamation-triangle"></i> {{ error }}
      <button type="button" class="btn-close" (click)="error = null"></button>
    </div>

    <!-- Formulário -->
    <div *ngIf="!loading" class="row">
      <div class="col-12">
        <div class="form-card">
          <!-- Steps do Wizard -->
          <div class="wizard-steps">
            <div class="step-item" [class.active]="currentStep === 1" [class.completed]="currentStep > 1" (click)="goToStep(1)">
              <span>1</span>
              <div class="step-label">Informações Básicas</div>
            </div>
            <div class="step-item" [class.active]="currentStep === 2" [class.completed]="currentStep > 2" (click)="goToStep(2)">
              <span>2</span>
              <div class="step-label">Itens da Preventiva</div>
            </div>
          </div>

          <!-- Step 1: Informações Básicas -->
          <div *ngIf="currentStep === 1" class="form-section">
            <h3 class="section-title">
              <i class="fas fa-info-circle me-2"></i>
              Informações Básicas
            </h3>
            
            <form [formGroup]="formStep1" class="row g-3">
              <div class="col-md-12">
                <label for="maintenanceName" class="form-label">Nome da Preventiva *</label>
                <input 
                  type="text" 
                  id="maintenanceName"
                  class="form-control"
                  formControlName="maintenanceName"
                  [class.is-invalid]="formStep1.get('maintenanceName')?.invalid && (formStep1.get('maintenanceName')?.touched || submitted)"
                  placeholder="Ex: Revisão 10.000 km">
                <div class="invalid-feedback" *ngIf="formStep1.get('maintenanceName')?.invalid && (formStep1.get('maintenanceName')?.touched || submitted)">
                  Nome é obrigatório
                </div>
              </div>

              <div class="col-md-12">
                <label for="description" class="form-label">Descrição</label>
                <textarea 
                  id="description"
                  class="form-control"
                  formControlName="description"
                  rows="3"
                  placeholder="Descreva a preventiva em detalhes..."></textarea>
              </div>

              <div class="col-md-12">
                <label for="instructions" class="form-label">Instruções</label>
                <textarea 
                  id="instructions"
                  class="form-control"
                  formControlName="instructions"
                  rows="4"
                  placeholder="Instruções para execução da preventiva..."></textarea>
              </div>

              <div class="col-md-4">
                <label for="vehicleType" class="form-label">Tipo de Veículo</label>
                <select 
                  id="vehicleType"
                  class="form-select"
                  formControlName="vehicleType">
                  <option value="">Selecione...</option>
                  <option *ngFor="let type of vehicleTypes" [value]="type">
                    {{ type }}
                  </option>
                </select>
              </div>

              <div class="col-md-4">
                <label for="vehicleBrand" class="form-label">Marca</label>
                <input 
                  type="text" 
                  id="vehicleBrand"
                  class="form-control"
                  formControlName="vehicleBrand"
                  placeholder="Ex: Toyota">
              </div>

              <div class="col-md-4">
                <label for="vehicleModel" class="form-label">Modelo</label>
                <input 
                  type="text" 
                  id="vehicleModel"
                  class="form-control"
                  formControlName="vehicleModel"
                  placeholder="Ex: Corolla">
              </div>

              <div class="col-md-4">
                <label for="targetMileage" class="form-label">Quilometragem Alvo</label>
                <input 
                  type="number" 
                  id="targetMileage"
                  class="form-control"
                  formControlName="targetMileage"
                  min="0"
                  placeholder="Ex: 10000">
              </div>

              <div class="col-md-4">
                <label for="estimatedCost" class="form-label">Custo Estimado (R$)</label>
                <input 
                  type="number" 
                  id="estimatedCost"
                  class="form-control"
                  formControlName="estimatedCost"
                  step="0.01"
                  min="0"
                  placeholder="0.00">
              </div>

              <div class="col-md-4">
                <label for="estimatedDurationHours" class="form-label">Duração Estimada (horas)</label>
                <input 
                  type="number" 
                  id="estimatedDurationHours"
                  class="form-control"
                  formControlName="estimatedDurationHours"
                  step="0.5"
                  min="0"
                  placeholder="Ex: 2">
              </div>

              <div class="col-md-4">
                <label for="orderIndex" class="form-label">Ordem</label>
                <input 
                  type="number" 
                  id="orderIndex"
                  class="form-control"
                  formControlName="orderIndex"
                  min="0"
                  placeholder="0">
              </div>

              <div class="col-md-12">
                <div class="form-check form-switch">
                  <input 
                    class="form-check-input" 
                    type="checkbox" 
                    id="isActive"
                    formControlName="isActive">
                  <label class="form-check-label" for="isActive">
                    Preventiva Ativa
                  </label>
                </div>
              </div>

              <div class="col-md-12">
                <div class="form-check form-switch">
                  <input 
                    class="form-check-input" 
                    type="checkbox" 
                    id="isRequired"
                    formControlName="isRequired">
                  <label class="form-check-label" for="isRequired">
                    Preventiva Obrigatória
                  </label>
                </div>
              </div>

              <div class="col-md-12">
                <div class="form-check form-switch">
                  <input 
                    class="form-check-input" 
                    type="checkbox" 
                    id="requiresSignature"
                    formControlName="requiresSignature">
                  <label class="form-check-label" for="requiresSignature">
                    Requer Assinatura
                  </label>
                </div>
              </div>
            </form>
          </div>

          <!-- Step 2: Itens da Preventiva -->
          <div *ngIf="currentStep === 2" class="form-section">
            <h3 class="section-title">
              <i class="fas fa-list me-2"></i>
              Itens da Preventiva
            </h3>

            <form [formGroup]="formStep2">
              <div formArrayName="items">
                <div *ngFor="let itemControl of itemsControls; let i = index" class="item-row mb-3 p-3 border rounded">
                  <div class="d-flex justify-content-between align-items-start mb-2">
                    <h5 class="mb-0">Item {{ i + 1 }}</h5>
                    <button 
                      type="button"
                      class="btn btn-sm btn-danger"
                      (click)="removeItem(i)">
                      <i class="fas fa-trash"></i>
                    </button>
                  </div>

                  <div [formGroupName]="i" class="row g-3">
                    <div class="col-md-6">
                      <label class="form-label">Buscar Item do Estoque</label>
                      <div class="position-relative">
                        <input 
                          type="text"
                          class="form-control"
                          [value]="stockSearchTerms[i] || ''"
                          (input)="searchStockItems(i, $any($event.target).value)"
                          (focus)="stockSearchTerms[i] && stockSearchTerms[i].length >= 2 ? showStockDropdown[i] = true : null"
                          (blur)="closeStockDropdown(i)"
                          placeholder="Digite o nome ou ID do item (mín. 2 caracteres)..."
                          autocomplete="off">
                        <i class="fas fa-search position-absolute" style="right: 15px; top: 50%; transform: translateY(-50%); color: #6c757d; pointer-events: none;"></i>
                        
                        <!-- Dropdown de resultados -->
                        <div 
                          *ngIf="showStockDropdown[i] && filteredStockItems[i] && filteredStockItems[i].length > 0"
                          class="dropdown-menu show w-100"
                          style="display: block; max-height: 300px; overflow-y: auto; margin-top: 2px;">
                          <div 
                            *ngFor="let stockItem of filteredStockItems[i]"
                            class="dropdown-item"
                            (click)="selectStockItem(i, stockItem)"
                            style="cursor: pointer; padding: 10px 15px;">
                            <div class="d-flex justify-content-between align-items-start">
                              <div class="flex-grow-1">
                                <strong>{{ stockItem.name }}</strong>
                                <small class="text-muted d-block">Código: {{ stockItem.code }}</small>
                                <small class="text-muted d-block" *ngIf="stockItem.description">
                                  {{ stockItem.description }}
                                </small>
                              </div>
                              <div class="text-end ms-2">
                                <small class="text-muted d-block">ID: {{ stockItem.id }}</small>
                                <small class="text-muted d-block" *ngIf="stockItem.unitCost">
                                  R$ {{ stockItem.unitCost | number:'1.2-2' }}
                                </small>
                                <small class="text-muted d-block">
                                  Qtd: {{ stockItem.availableQuantity || 0 }} {{ stockItem.unit || 'UN' }}
                                </small>
                              </div>
                            </div>
                          </div>
                        </div>
                        
                        <!-- Mensagem quando não há resultados -->
                        <div 
                          *ngIf="showStockDropdown[i] && filteredStockItems[i] && filteredStockItems[i].length === 0 && stockSearchTerms[i] && stockSearchTerms[i].length >= 2"
                          class="dropdown-menu show w-100"
                          style="display: block; margin-top: 2px;">
                          <div class="dropdown-item-text text-muted text-center">
                            Nenhum item encontrado
                          </div>
                        </div>
                      </div>
                      <small class="form-text text-muted">
                        <i class="fas fa-info-circle"></i> Digite pelo menos 2 caracteres para buscar por nome ou código, ou digite um número para buscar por ID
                      </small>
                    </div>

                    <div class="col-md-6">
                      <label class="form-label">Nome do Item *</label>
                      <input 
                        type="text"
                        class="form-control"
                        formControlName="itemName"
                        [class.is-invalid]="itemControl.get('itemName')?.invalid && (itemControl.get('itemName')?.touched || submitted)"
                        placeholder="Ex: Troca de Óleo">
                      <div class="invalid-feedback" *ngIf="itemControl.get('itemName')?.invalid && (itemControl.get('itemName')?.touched || submitted)">
                        Nome do item é obrigatório
                      </div>
                    </div>

                    <div class="col-md-12">
                      <label class="form-label">Descrição</label>
                      <textarea 
                        class="form-control"
                        formControlName="description"
                        rows="2"
                        placeholder="Descrição do item..."></textarea>
                    </div>

                    <div class="col-md-12">
                      <label class="form-label">Instruções</label>
                      <textarea 
                        class="form-control"
                        formControlName="instructions"
                        rows="2"
                        placeholder="Instruções para este item..."></textarea>
                    </div>

                    <div class="col-md-3">
                      <label class="form-label">Quantidade *</label>
                      <input 
                        type="number"
                        class="form-control"
                        formControlName="quantity"
                        step="0.01"
                        min="0.01"
                        [class.is-invalid]="itemControl.get('quantity')?.invalid && (itemControl.get('quantity')?.touched || submitted)">
                      <div class="invalid-feedback" *ngIf="itemControl.get('quantity')?.invalid && (itemControl.get('quantity')?.touched || submitted)">
                        Quantidade é obrigatória e deve ser maior que zero
                      </div>
                    </div>

                    <div class="col-md-3">
                      <label class="form-label">Unidade *</label>
                      <select 
                        class="form-select"
                        formControlName="unit"
                        [class.is-invalid]="itemControl.get('unit')?.invalid && (itemControl.get('unit')?.touched || submitted)">
                        <option value="">Selecione...</option>
                        <option *ngFor="let unit of units" [value]="unit">
                          {{ unit }}
                        </option>
                      </select>
                    </div>

                    <div class="col-md-3">
                      <label class="form-label">Tipo de Item</label>
                      <select 
                        class="form-select"
                        formControlName="itemType">
                        <option *ngFor="let type of itemTypes" [value]="type">
                          {{ type }}
                        </option>
                      </select>
                    </div>

                    <div class="col-md-3">
                      <label class="form-label">Custo Estimado (R$)</label>
                      <input 
                        type="number"
                        class="form-control"
                        formControlName="estimatedCost"
                        step="0.01"
                        min="0"
                        placeholder="0.00">
                    </div>

                    <div class="col-md-3">
                      <label class="form-label">Ordem</label>
                      <input 
                        type="number"
                        class="form-control"
                        formControlName="orderIndex"
                        min="0"
                        [value]="i">
                    </div>

                    <div class="col-md-3">
                      <div class="form-check form-switch mt-4">
                        <input 
                          class="form-check-input" 
                          type="checkbox" 
                          formControlName="isRequired">
                        <label class="form-check-label">
                          Item Obrigatório
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <button 
                type="button"
                class="btn btn-outline-primary mt-3"
                (click)="addItem()">
                <i class="fas fa-plus me-2"></i>
                Adicionar Item
              </button>
            </form>
          </div>

          <!-- Navegação entre Steps -->
          <div class="form-actions mt-4">
            <div class="d-flex justify-content-between">
              <button 
                type="button" 
                class="btn btn-secondary"
                (click)="previousStep()"
                [disabled]="currentStep === 1">
                <i class="fas fa-arrow-left me-2"></i>
                Anterior
              </button>

              <div>
                <button 
                  type="button" 
                  class="btn btn-outline-secondary me-2"
                  (click)="cancel()">
                  <i class="fas fa-times me-2"></i>
                  Cancelar
                </button>

                <button 
                  *ngIf="currentStep < totalSteps"
                  type="button" 
                  class="btn btn-primary"
                  (click)="nextStep()">
                  Próximo
                  <i class="fas fa-arrow-right ms-2"></i>
                </button>

                <button 
                  *ngIf="currentStep === totalSteps"
                  type="button" 
                  class="btn btn-success"
                  (click)="onSubmit()"
                  [disabled]="isSubmitting">
                  <i class="fas fa-save me-2"></i>
                  {{ isSubmitting ? 'Salvando...' : 'Salvar Preventiva' }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</app-side-menu>

